import { Typography } from "@mui/material";

const PhoneNumberInput = ({ value, onChange, error, readOnly, color }) => (
  <>
    <input
      type="text"
      placeholder="(000) 000-0000"
      style={{
        border: '1px solid #b8bdc9',
        borderRadius: '3px',
        padding: '10px',
        width: '100%',
        fontSize: '12px',
        fontWeight: 700,
        color,
        appearance: 'none',
        MozAppearance: 'textfield',
        marginBottom: '8px',
      }}
      readOnly={readOnly}
      value={value}
      onChange={onChange}
    />
    {error && value !== '' && (
      <Typography variant="subtitle1" color="#FF0000" fontWeight={700}>
        {error}
      </Typography>
    )}
  </>
);

export default PhoneNumberInput;
